import { css } from 'styled-components';

export const RatesAndTermsPageStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;

  .header-section {
    background-color: #e6f8fc;
    padding: 40px 20px;
    text-align: center;
  }

  .subtitle {
    color: #333;
    font-size: 18px;
    margin-bottom: 8px;
    font-weight: 600;
  }

  .title {
    color: #003057;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  .content-section {
    padding: 40px 20px;
    max-width: 800px;
    margin: 0 auto;
  }

  p {
    margin-bottom: 16px;
    line-height: 1.5;
  }

  strong {
    font-weight: 600;
  }
`;
